import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/lib/toast.js';
import { queryKeys } from '@/lib/query/keys.js';
import { ignoreFulfillmentLines, retryFulfillmentLines } from './api.js';

/** Réessai (unitaire ou groupé) des lignes du Suivi Martelet en erreur (`02` §11). */
export function useRetryFulfillmentLines() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (lineIds: string[]) => retryFulfillmentLines(lineIds),
    onSuccess: (result) => {
      const failed = result.results.filter((entry) => !entry.ok);
      if (failed.length === 0) {
        toast.success(
          result.results.length > 1 ? `${String(result.results.length)} ligne(s) réessayée(s).` : 'Ligne réessayée.',
        );
      } else {
        toast.error(`${String(failed.length)} ligne(s) en échec sur ${String(result.results.length)}.`);
      }
      void queryClient.invalidateQueries({ queryKey: queryKeys.runs.all });
    },
    onError: (error: unknown) => {
      toast.fromError(error);
    },
  });
}

/** « Ignorer » (avec motif) des lignes du Suivi Martelet traitées à la main (`02` §11). */
export function useIgnoreFulfillmentLines() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ lineIds, reason }: { lineIds: string[]; reason: string }) => ignoreFulfillmentLines(lineIds, reason),
    onSuccess: (result) => {
      toast.success(
        result.results.length > 1 ? `${String(result.results.length)} ligne(s) ignorée(s).` : 'Ligne ignorée.',
      );
      void queryClient.invalidateQueries({ queryKey: queryKeys.runs.all });
    },
    onError: (error: unknown) => {
      toast.fromError(error);
    },
  });
}
